import React, { useState } from 'react'
import { Tooltip } from 'antd'
import styled from 'styled-components'
import { Flex, icons, ColourButton } from 'portal/lib/primitives'
import { colours, sizes } from '@qflow/theme'

export function OnlyOneItemFilter({ onToggle }) {
  const [onlyShowOneItem, setOnlyShowOneItem] = useState(
    localStorage.getItem('only-one-item-filter')
  )

  const toggleFilter = () => {
    const newState =
      !onlyShowOneItem || onlyShowOneItem === 'false' ? 'true' : 'false'
    setOnlyShowOneItem(newState)
    localStorage.setItem('only-one-item-filter', newState)
    onToggle(newState)
  }

  return (
    <ButtonContainer>
      <FilterButton
        id="OnlyOneItemFilter"
        onClick={toggleFilter}
        $onlyShowOneItem={onlyShowOneItem}
      >
        <Tooltip
          title={
            onlyShowOneItem === 'true'
              ? 'Only showing records with one waste item'
              : 'Only show records with one waste item'
          }
        >
          <icons.Table size={sizes.SMALL} />{' '}
          {onlyShowOneItem === 'true' ? 'Single Waste Item' : 'All Waste Items'}
        </Tooltip>
      </FilterButton>
    </ButtonContainer>
  )
}

const ButtonContainer = styled(Flex.Col)`
  flex: 0 0 auto;
  align-items: flex-end;
`
const FilterButton = styled(ColourButton.Basic)`
  border-radius: 25px;
  color: ${({ $onlyShowOneItem }) =>
    $onlyShowOneItem === 'true' ? colours.ORANGE : colours.DARK_GREY};
  background-color: ${({ $onlyShowOneItem }) =>
    $onlyShowOneItem === 'true' ? '#FFF2EB' : colours.WHITE};
  border-color: ${({ $onlyShowOneItem }) =>
    $onlyShowOneItem === 'true' ? colours.ORANGE : colours.BORDER_GREY};

  &:hover {
    background: transparent;
    color: ${({ $onlyShowOneItem }) =>
      $onlyShowOneItem === 'true' ? colours.ORANGE : colours.DARK_GREY};
    border-color: ${({ $onlyShowOneItem }) =>
      $onlyShowOneItem === 'true' ? colours.ORANGE : colours.DARK_GREY};
  }

  &:focus {
    color: ${({ $onlyShowOneItem }) =>
      $onlyShowOneItem === 'true' ? colours.ORANGE : colours.DARK_GREY};
    background-color: ${({ $onlyShowOneItem }) =>
      $onlyShowOneItem === 'true' ? '#FFF2EB' : colours.WHITE};
  }

  &:hover:focus {
    background: transparent;
  }

  > SVG {
    color: ${({ $onlyShowOneItem }) =>
      $onlyShowOneItem === 'true' ? colours.ORANGE : colours.BATTLESHIP_GREY};
  }

  &:hover > SVG {
    color: ${({ $onlyShowOneItem }) =>
      $onlyShowOneItem === 'true' ? colours.ORANGE : colours.CHARCOAL_GREY};
  }
`
